import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { ensureListing } from '../../util/data';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_PROVIDER_COMMISSION, propTypes } from '../../util/types';

import css from './BookingBreakdown.module.css';

const { Money } = sdkTypes;

// Validate the assumption that the commission exists and the amount
// is zero or negative.
const isValidCommission = commissionLineItem => {
  return commissionLineItem.lineTotal instanceof Money;
  // && commissionLineItem.lineTotal.amount >= 0;
};

const LineItemProviderCommissionMaybe = props => {
  const { transaction, isProvider, listing } = props;

  const providerCommissionLineItem = transaction.attributes.lineItems.find(
    item => item.code === LINE_ITEM_PROVIDER_COMMISSION && !item.reversal
  );

  //Checking if custom Currency is set to Euro
  const currentListing = ensureListing(listing);
  const currencyCheck1 = (customCurrency, shareTribePrice) => {
    if(customCurrency!==undefined){
      if ((customCurrency).includes('Euro')){
        return (((shareTribePrice.toFixed(2)).toString()).substr(0)+ "€");
      }else{
        return ("$"+shareTribePrice);
      }
    }else{
      return ("$"+shareTribePrice);
    }
  }
  const currencyCheck = (customCurrency, shareTribePrice) => {
    if(customCurrency!==undefined){
      if ((customCurrency).includes('Euro')){
        return (shareTribePrice.substr(0)+ "€");
      }else{
        return ("$"+shareTribePrice);
      }
    }else{
      return ("$"+shareTribePrice);
    }
  }


  // If commission is passed it will be shown as a fee already reduces from the total price
  let commissionItem = null;

  // Flex Template for Web is using the default transaction process (https://www.sharetribe.com/docs/background/transaction-process/#sharetribe-flex-default-transaction-process)
  // which containt provider commissions so by default the providerCommissionLineItem should exist.
  // If you are not using provider commisison you might want to remove this whole component from BookingBreakdown.js file.
  if (isProvider && providerCommissionLineItem) {
    if (!isValidCommission(providerCommissionLineItem)) {
      // eslint-disable-next-line no-console
      console.error('invalid commission line item:', providerCommissionLineItem);
      throw new Error('Commission should be present and the value should be zero or negative');
    }

    // const commission = providerCommissionLineItem.lineTotal;
    // commission.amount = commission.amount * seats * -1;
    // console.log(commission.amount);
    // const formattedCommission = commission ? formatMoney(intl, commission) : null;
    console.log('TRANS: ' + JSON.stringify(transaction.attributes.payinTotal.amount));
    const toBePaid = ((transaction.attributes.payinTotal.amount / 100) * 0.15).toFixed(2);

    const onSite = ((transaction.attributes.payinTotal.amount / 100).toFixed(2)-toBePaid);
    //const formattedToBePaid = formatMoney(intl, toBePaid);
    //const goToEmail = intl.formatMessage({ id: 'Imprint.emailinfo' });
    commissionItem = (
      <div>
       
       <div className={css.lineItem2}>
          <span className={css.itemLabel}>
            <FormattedMessage id="BookingBreakdown.upfront" />
          </span>
          <span className={css.totalPrice}></span>
          <div className={css.totalPrice}>{currencyCheck(currentListing.attributes.publicData.customCurrency, toBePaid)}</div>
          </div>
          <div>
          <span className={css.commissionLabel}>
            <FormattedMessage id="BookingBreakdown.upfrontText" />
          </span>
        </div>
        <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="BookingBreakdown.onSite" />
          </span>
          <span className={css.totalPrice}></span>
          <div className={css.totalPrice}>{currencyCheck1(currentListing.attributes.publicData.customCurrency, onSite)}</div>
        </div>
        <hr className={css.totalDivider2} />

      </div>
    );
  }

  return commissionItem;
};

LineItemProviderCommissionMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemProviderCommissionMaybe;
